import React, { useEffect } from "react";
import {
  useLocation,
  useNavigate,
} from "react-router-dom";

import { useTranslation } from "react-i18next";

const RoutesComp = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);


  const Token = localStorage.getItem("Token");


  useEffect(() => {
    if (Token) {
      window.location.href = `${process.env.REACT_APP_MUNASEB_AI}/?isaqar=true&token=${Token}`;
    }
  }, [Token]);

  if (Token) {
    return (
      <div className="h-screen flex items-center justify-center">
        <p className="text-xl font-semibold">{t("loading")}</p>
      </div>
    );
  }

  return (
    <div className="h-screen flex items-center justify-center">
      <p className="text-xl font-semibold">{t("noToken")}</p>
    </div>
  );
};

export default RoutesComp;
